export function transformData(response) {
  const map = {
    name: 'name',
    description: 'short_description',
    contribution: 'what_will_you_learn',
    requirements: 'requirements',
    message: 'banner_message',
    language: 'cc_language',
    subtitle: 'subtitle'
  };

  const courseInformation = {};

  if (!Array.isArray(response)) {
    return courseInformation;
  }

  response.forEach(({ code, value }) => {
    const lastWord = code.split('_').pop().toLowerCase();
    if (map[lastWord]) {
      courseInformation[map[lastWord]] = value;
    }
  });

  return courseInformation;
}

export function transformDataGeneric(data) {
  return data.reduce((acc, item) => {
    // Obtener la última parte del código después del último guion bajo (_)
    const key = item.code.split('_').slice(-1)[0].toLowerCase();
    acc[key] = item.value;
    return acc;
  }, {});
}

export function getBaseCode(code) {
  if (typeof code !== 'string') return ''; // Validar que sea un string
  const lastUnderscoreIndex = code.lastIndexOf('_');
  return lastUnderscoreIndex !== -1 ? code.substring(0, lastUnderscoreIndex) : code;
}

export function transformConsultantDataVariables(
  data,
  variableMap,
  consultant = 'consultant_data_external'
) {
  return {
    ...data,
    consultant_data_external: data[consultant].map((consultant) => {
      const extractedData = {};

      // Inicializar las claves con valores vacíos
      Object.values(variableMap).forEach((key) => (extractedData[key] = ''));

      consultant.data_variables.forEach(({ id, value }) => {
        if (variableMap[id]) {
          extractedData[variableMap[id]] = value;
        }
      });

      return {
        ...consultant,
        ...extractedData,
        data_variables: undefined
      };
    })
  };
}

export function transformConsultantsData(consultantData, variableMap) {
  function transformConsultants(consultants = []) {
    return consultants.map((consultant) => {
      const extractedVariables = {};

      consultant.data_variables?.forEach((item) => {
        if (variableMap[item.id]) {
          extractedVariables[variableMap[item.id]] = item.value;
        }
      });

      return {
        ...consultant,
        ...extractedVariables,
        data_variables: undefined // Eliminamos data_variables
      };
    });
  }

  return {
    consultants_external: transformConsultants(consultantData?.consultants_external),
    consultants_internal: transformConsultants(consultantData?.consultants_internal)
  };
}

export function transformDataVariableGeneric(response = [], variablesName = {}) {
  return response.map((item) => {
    let transformedItem = { ...item };

    // Extraer las variables que coincidan con variablesName
    item.data_variables.forEach((variable) => {
      if (variablesName[variable.id]) {
        transformedItem[variablesName[variable.id]] = variable.value;
      }
    });

    // Eliminar data_variables del resultado final
    delete transformedItem.data_variables;

    return transformedItem;
  });
}
